//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
  export default {
    name: "virtual-material-management",
    components: {
      divSpan,
    },
    data() {
      return {
        uploadUrl:process.env.API_ROOT,
        refresh:true,
        wrapperHeight: 0,
        allLoaded: false,
        config: {
          title: '虚拟物料维护',
          url: 'api/invmaterial/page',
          workflowSearchBean: {},
          fixRules: [],
          inputCondition: {
            placeholder: '虚拟物料编号',
            searchCondition: 'key',
            rules: [{
              field: "invMatCode",
              option: "LIKE_ANYWHERE"
            }]
          },
        },
        searchData: {},
        list: []
      }
    },
    methods: {
      goDetail(id){
        this.dataId = id
        this.$router.push('/virtual-material-management-view/'+id)
      },
      getList(e,met,bol){
        this.$nextTick(()=>{
          if(bol){
            this.list = this.list.concat(e);
          }else{
            this.list = e;
          }
          if(met === 'top'){
            this.$refs.loadmore.onTopLoaded();
          }
          if(met === 'bottom'){
            this.$refs.loadmore.onBottomLoaded();
          }
        })
      },
      init: function () {
        // 父控件要加上高度，否则会出现上拉不动的情况
        this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
      },
      loadTop(){
        this.$refs.header.getlist(true);
      },
      loadBottom(){
        this.$refs.header.getMore();
      }
    },
    mounted() {
      this.init();
      this.$refs.header.getlist();
    }
  }



// WEBPACK FOOTER //
// ./src/page/virtual-material-management/virtual-material-management.vue